import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import GoogleAnalytics from "./components/GoogleAnalytics";
import { CountryProvider } from "./contexts/CountryContext";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <StrictMode>
    <BrowserRouter basename={"/"}>
      <CountryProvider>
        <GoogleAnalytics />
        <App />
      </CountryProvider>
    </BrowserRouter>
  </StrictMode>
);
